import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { Grant } from './Grant';

export class GrantResource extends FBaseService {
  public async getGrantsByAccountAndQualDates(fiId: string, akk: string, qualStartDate: string, qualEndDate: string): Promise<Grant[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/grant/${akk}?qualificationStart=${qualStartDate}&qualificationEnd=${qualEndDate}`,
    );
    const results: Grant[] = response.data.data;
    return results;
  }

  public async getOutstandingGrantsByAccount(fiId: string, akk: string): Promise<Grant[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/grant/${akk}/outstanding`,
    );
    const results: Grant[] = response.data.data;
    return results;
  }
}

export default GrantResource;
